<template>
	<div class="form-group">
		<p style="white-space: pre-wrap;">{{ field.text }}</p>
	</div>
</template>

<script>
export default {
	props: ['field']
};
</script>
